import React, { useEffect, useState } from 'react'
import Tabs from '../../../partials/Tabs/index.js'
import Questions from './Questions'
import TabContent from '../../../partials/TabsContainer/TabContent.js'
import Header from '../../../partials/Header'
import "./Orbit.scss"
import WrapUp from './Wrapup/index.js'

const Orbit = (props) => {

    const { data, goToPrevious, buttonsState, updateButtonState, onComplete } = props
    const [ view, setView ] = useState()
    const [ questionsAnswers, setQuestionAnswers ] = useState()

    useEffect(() => {
        if(!view) setView('questions')                                                  
    }, []) 

    const onTabsComplete = () => {
        setView('questions')
    }
    const onQuestionsComplete = (feedback) => {
        updateButtonState(feedback)
        setQuestionAnswers(feedback)
        setView('wrapup')

        // onComplete(feedback)
    }
    const handleWrapUpComplete = () => {

        console.log('handleWrapUpComplete')
        onComplete(questionsAnswers)
    }

    const handleBackButton = () =>{
        // it must go to tabbed content
        if(view === 'wrapup') setView('questions')
        if(view === 'questions') goToPrevious()
    }
    return (
        <>
            <Header 
                title={data.title} 
                intro={data.description}
                buttonset={buttonsState} 
                backButtonHandler={()=>handleBackButton()}
            />

            <div className="orbit-container">
                
                <div className="orbit-body">
                    { view === 'tabs' && 
                        <Tabs 
                            tabsArray={data.tabs} 
                            nextView='questions' 
                            onComplete={onTabsComplete} 
                            tabContentComponent={TabContent} /> 
                    }
                    { view === 'questions' && 
                        <Questions 
                            data={data.questions} 
                            onComplete={onQuestionsComplete} /> 
                    }
                    { view === 'wrapup' && 
                        <WrapUp 
                            conclusions={data.conclusions} 
                            questionsAnswers={questionsAnswers}
                            onComplete={handleWrapUpComplete} /> 
                    }
                    
                </div>
            </div>
        </>
    );
}

export default Orbit